import { motion, useReducedMotion } from "framer-motion";

export default function Marquee({ items = [], ariaLabel = "marquee" }) {
  const reduced = useReducedMotion();
  const row = [...items, ...items]; // duplicate for seamless loop

  return (
    <section
      data-testid="care-marquee"
      aria-label={ariaLabel}
      className="relative py-10 md:py-14 bg-[#1A2621] text-[#FDFBF7] overflow-hidden border-y border-[#1A2621]"
    >
      <div className="flex whitespace-nowrap">
        <motion.div
          className="flex gap-16 pr-16"
          animate={reduced ? undefined : { x: ["0%", "-50%"] }}
          transition={{
            duration: 36,
            ease: "linear",
            repeat: Infinity,
          }}
        >
          {row.map((t, i) => (
            <span
              key={i}
              className="font-serif-display text-3xl md:text-5xl lg:text-6xl tracking-tight flex items-center gap-16"
            >
              {t}
              <span
                aria-hidden
                className="inline-block w-2.5 h-2.5 rounded-full bg-[#C86A51]"
              />
            </span>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
